import { render, staticRenderFns } from "./FAQMenu.vue?vue&type=template&id=7a0e9907&scoped=true&"
import script from "./FAQMenu.vue?vue&type=script&lang=js&"
export * from "./FAQMenu.vue?vue&type=script&lang=js&"
import style0 from "./FAQMenu.vue?vue&type=style&index=0&id=7a0e9907&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0e9907",
  null
  
)

export default component.exports